import { DestroyRef, Pipe, PipeTransform, inject } from '@angular/core';
import { StockService } from './stock.service';
import { StockMap } from '@pedix-workspace/shared-stock';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'pxwStockWarning',
  standalone: true,
})
export class StockWarningPipe implements PipeTransform {
  private stockService = inject(StockService);
  private translocoService = inject(TranslocoService);
  private destroyRef = inject(DestroyRef);

  stock$: Observable<StockMap>;

  constructor() {
    this.stock$ = toObservable(this.stockService.stock);
  }

  transform(itemId: string): Observable<string | undefined> {
    return combineLatest([this.stock$, this.translocoService.langChanges$]).pipe(
      takeUntilDestroyed(this.destroyRef),
      map(([stock]) => {
        const stockInfo = stock.getStockInfoByItem(itemId);
        if (stockInfo.missingStock <= 0) {
          return undefined;
        }
        if (stockInfo.availableStock === 0) {
          return this.translocoService.translate('product.fixWithoutStockIssuesCta');
        }
        return this.translocoService.translate('product.insufficientStock', {
          totalStock: stockInfo.availableStock,
        });
      }),
    );
  }
}
